import { Component, inject, OnInit } from '@angular/core';
import { SortOrder } from '@modules/common/types/sort-order';
import { NotebookListStateService } from '@modules/notes/services/notebook-list-state.service';
import { NotebooksService } from '@modules/notes/services/notebooks.service';
import { Notebook } from '@modules/notes/types/notebook';
import { NotebooksFilters } from '@modules/notes/types/notebooks-filters';
import { NotebooksListState } from '@modules/notes/types/notebooks-list-state';
import { KnowledgeStitchSectionComponent } from '../stitch-section/stitch-section.component';

@Component({
  selector: 'app-knowledge-notebooks-section',
  templateUrl: './notebooks-section.component.html',
  styleUrls: ['../stitch-section/stitch-section.component.less'],
  standalone: false,
  providers: [
    ...NotebookListStateService.providers({
      defaultSort: {
        by: 'score',
        order: SortOrder.DESC,
      },
    }),
  ],
})
export class KnowledgeNotebooksSectionComponent
  extends KnowledgeStitchSectionComponent<Notebook, NotebooksFilters>
  implements OnInit
{
  protected readonly listStateService = inject(NotebookListStateService, { self: true });
  protected readonly stitchService = inject(NotebooksService);

  public override ngOnInit(): void {
    this.state = new NotebooksFilters({ withEmpty: true });
    super.ngOnInit();
  }

  public handleFilter(listState: NotebooksListState): void {
    this.filterChange.emit();

    // Read directly, not streamed: handleFilter only runs on a user action, which is always after
    // the space settings have loaded, so the zone is already the account's (SBUX-829).
    this.filters = new NotebooksFilters({ displayTimeZone: this.displayTimeZoneService.timeZone() });
    this.filters.applyListState(listState);

    this.updateFilters();
  }
}
